export default {
  // Hero
  "home.hero.title_line1": "Federația Organizațiilor",
  "home.hero.title_line2": "de Pescari",
  "home.hero.title_line3": "de la Marea Neagră",
  "home.hero.title_line_de": "de",
  "home.hero.title_line_full": "Pescari de la Marea Neagră",
  "home.hero.title_line1_full": "Federația Organizațiilor de",
  "home.hero.title_line2_full": "Pescari de la Marea Neagră",
  "home.hero.subtitle_line1": "Vocea unitară a pescuitului comercial la Marea Neagră.",
  "home.hero.subtitle_line2": "Protejăm tradiția, reglementăm viitorul.",
  "home.hero.cta": "Alătură-te federației",

  // Stats
  "home.stats.founded": "Anul fondării",
  "home.stats.members": "Membri",
  "home.stats.fishermen": "Pescari reprezentați",
  "home.stats.tons": "tone",

  // About / President
  "home.about.label": "Un mesaj de la",
  "home.about.title": "Președintele FOPMN",
  "home.about.quote1": "În toți acești ani, plini de provocări pentru sectorul pescăresc, marcați de schimbări legislative continue și de dificultăți financiare, logistice și de personal, am fost aici, pe metereze, reprezentând cu fermitate interesele micilor pescari în fața instituțiilor statului și a mass-mediei, sprijinind dezvoltarea sectorului și promovând gestionarea durabilă a resurselor piscicole.",
  "home.about.quote2": "Cea mai importantă resursă a sectorului o reprezintă pescarii profesioniști – oamenii care, prin cunoștințele, experiența și pasiunea muncii lor, reușesc să mențină viu acest meșteșug și să aducă pe mesele românilor produse pescărești de origine românească.",
  "home.about.name": "Laurențiu Mirea",
  "home.about.role": "Președinte FOPMN",

  // Gallery Teaser (Home page — Coverflow 3D)
  "home.gallery_teaser.label": "Din teren",
  "home.gallery_teaser.title": "Pescarii FOPMN în acțiune",
  "home.gallery_teaser.description": "Descoperă galeria noastră completă cu videoclipuri și imagini din activitatea zilnică a pescarilor profesioniști de la Marea Neagră. Vei găsi înregistrări autentice de pe mare, din port și de la punctele de debarcare.",
  "home.gallery_teaser.cta": "Vezi galeria completă",

  // News
  "home.news.label": "Ultimele noutăți",
  "home.news.title": "Știri",
  "home.news.all": "Toate știrile",
  "home.news.read_more": "Citește mai mult",
  "home.news.find_more": "Află mai multe",

  // Featured Cards
  "home.cards.fishing": "Pescuitul românesc",
  "home.cards.fishermen": "Pescarii profesioniști",
  "home.cards.gastronomy": "Promovarea gastronomiei pescărești",

  // Sponsor
  "home.sponsor.title": "Susține pescuitul profesionist de la Marea Neagră",
  "home.sponsor.description": "Sprijinul tău ne ajută să rămânem o voce unitară și puternică, capabilă să apere drepturile pescarilor profesioniști, să susțină negocierile privind cotele anuale de pescuit și să protejeze viitorul sectorului pescăresc de la Marea Neagră.",
  "home.sponsor.cta": "Sponsorizează",
};